@layer components {
  .form {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;

    /* Najechanie na przycisk czyszczenia też podświetla pole. */
    &:hover, &:focus-within {
      > input {
        background-color: var(--blue);
        color: var(--white);
      }

      .clear {
        color: var(--white);
      }
    }
  }

  .input {
    composes: field from '../styles/field.module.css';
    position: relative;
    padding: var(--space-small) var(--space-large);
    width: 100%;
    border: none;
    border-radius: var(--radius);
    text-align: center;

    /* Fokus widać po zmianie tła całego pola. */
    &:focus-visible {
      outline: none;
    }

    &::-webkit-search-cancel-button {
      display: none;
    }

    &::placeholder {
      color: inherit;
      opacity: 0.5;
    }

    &::selection {
      background-color: var(--white);
      color: var(--navy);
    }
  }

  .clear {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    color: var(--navy);
    transition: color var(--duration) var(--easing);

    svg {
      width: 12px;
    }
  }
}
